import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Menu, MessageCircle, X } from "lucide-react";
import { BrandLogo } from "@/components/layout/BrandLogo";
import { MegaMenu } from "@/components/layout/MegaMenu";
import { MobileMenu } from "@/components/layout/MobileMenu";
const NAV_LINK =
  "px-4 py-2 min-h-[44px] inline-flex items-center text-sm font-semibold text-ink rounded-full hover:bg-brand-50 hover:text-brand-600 transition-colors";

export function Header({ onOpenChat }) {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 glass-nav border-b-2 border-brand-100" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <BrandLogo showTagline={false} />

          <nav className="hidden lg:flex items-center space-x-1" aria-label="Main">
            <Link to="/about" className={NAV_LINK}>
              About Us
            </Link>
            <MegaMenu />
            <Link to="/contact" className={NAV_LINK}>
              Contact
            </Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <button
              type="button"
              onClick={() => onOpenChat?.()}
              className="min-h-[44px] text-sm font-semibold text-ink hover:text-brand-600 px-3 py-2 flex items-center gap-2 transition-colors"
            >
              <MessageCircle className="w-4 h-4 text-brand-500" aria-hidden="true" />
              <span>Talk to us</span>
            </button>
            <Link
              to="/consultation"
              className="bg-sun-500 hover:bg-sun-400 text-ink text-sm font-bold px-5 py-2.5 min-h-[44px] rounded-lg transition-colors flex items-center gap-2"
            >
              <span>Book Consultation</span>
              <ChevronRight className="w-3.5 h-3.5" aria-hidden="true" />
            </Link>
          </div>

          <div className="lg:hidden flex items-center">
            <button
              type="button"
              aria-label={mobileOpen ? "Close navigation" : "Open navigation"}
              aria-expanded={mobileOpen}
              onClick={() => setMobileOpen((v) => !v)}
              className="inline-flex h-11 w-11 items-center justify-center rounded-full text-ink hover:bg-brand-50"
            >
              {mobileOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      <MobileMenu open={mobileOpen} onOpenChat={() => { setMobileOpen(false); onOpenChat?.(); }} />
    </header>
  );
}
